import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Caja } from 'src/app/model/index.model';
import { BaseService } from './base.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CajaService extends BaseService<Caja> {

    constructor(protected override http: HttpClient) {
        super(http, 'caja');
    }

    isCajaByUserAndFecha(usuario, fe1, fe2) {
        this.other_header = UturuncoUtils.getHeader();
        let body = { query: { usuario: usuario, inicio: fe1, fin: fe2 } }
        return firstValueFrom(this.http
            .post(this.api + "/isCajaByUserAndFecha/", body, { headers: this.other_header }));
    }


}
